// extracted by mini-css-extract-plugin
export default {"mobileTab":"mobileTab--Wf7cm","mobileWrap":"mobileWrap--Wf7cm","tabText":"tabText--Wf7cm","prev":"prev--Wf7cm","next":"next--Wf7cm"};